export default "__VITE_ASSET__Cz8W087r__"